import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface CloseGLPeriodApiRequest {
  companyId: number | string;
  glPeriodId: number;
}

const useCloseGLPeriodApi = () => {
  const call = useCallback(async (request?: CloseGLPeriodApiRequest) => {
    try {
      const res = await axiosInstance.post<CloseGLPeriodApiRequest[]>(api.closeGLPeriod, {
        companyId: Number(request?.companyId),
        glPeriodId: request?.glPeriodId,
      });
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute, isLoading } = useAsync(call, false);

  return {
    updateCloseGLPeriod: execute,
    isUpdatingCloseGLPeriod: isLoading,
  };
};

export default useCloseGLPeriodApi;
